/* HelloTech MT5 Ultra — animasyonlar, alt menü, mobil yapışkan sepet. Bağımlılık yok. */
(() => {
  if (window.__htMt5) return;
  window.__htMt5 = true;

  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const roots = () => document.querySelectorAll(".ht");

  const init = () => {
    // Shopify tema düzenleyicisinde animasyonları kapat: düzenleme sırasında içerik hep görünür olsun.
    const motion = !reduce && !window.Shopify?.designMode;
    roots().forEach((r) => r.classList.toggle("ht-motion", motion));
    observe(motion);
    timecode();
    eta();
    subnav();
    sticky();
  };

  /* ---------- Görünürlük: deklanşör, odak, yükselme, HUD, sayaç ---------- */
  let io;
  const observe = (motion) => {
    io?.disconnect();
    const targets = document.querySelectorAll(".ht [data-ht-shutter], .ht [data-ht-focus], .ht [data-ht-rise], .ht [data-ht-ai], .ht [data-ht-phone]");
    if (!motion) {
      targets.forEach((el) => el.classList.add("is-in"));
      return;
    }
    io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        const el = e.target;
        el.classList.add("is-in");
        io.unobserve(el);
        el.querySelectorAll(".ht-hud").forEach((h, i) => setTimeout(() => typeHud(h), 650 + i * 300));
        el.querySelectorAll("[data-ht-count]").forEach(countUp);
        if (el.hasAttribute("data-ht-ai")) aiAnswer(el);
        if (el.hasAttribute("data-ht-phone")) phoneTaps(el);
      });
    }, { threshold: 0.28, rootMargin: "0px 0px -6% 0px" });
    targets.forEach((el) => io.observe(el));
    // Sayaçlar fotoğraf dışında da olabilir
    document.querySelectorAll(".ht [data-ht-stats]").forEach((s) => {
      const o = new IntersectionObserver(([e]) => {
        if (!e.isIntersecting) return;
        o.disconnect();
        s.querySelectorAll("[data-ht-count]").forEach(countUp);
      }, { threshold: 0.5 });
      o.observe(s);
    });
  };

  const typeHud = (hud) => {
    const span = hud.querySelector("[data-ht-type]");
    if (!span || hud.classList.contains("is-done")) return;
    const text = span.dataset.htType || span.textContent;
    span.dataset.htType = text;
    span.textContent = "";
    hud.classList.add("is-typing");
    let i = 0;
    const step = () => {
      span.textContent = text.slice(0, ++i);
      if (i < text.length) setTimeout(step, 28 + Math.random() * 40);
      else setTimeout(() => hud.classList.replace("is-typing", "is-done"), 900);
    };
    step();
  };

  // "3,5 sa", "2000 mAh", "8 MP", "%84" gibi değerlerdeki ilk sayıyı sayar; biçimi korur.
  const countUp = (el) => {
    if (el.dataset.htCounted) return;
    el.dataset.htCounted = "1";
    const raw = el.textContent;
    const m = raw.match(/\d+(?:[.,]\d+)?/);
    if (!m || /×/.test(raw) || !/^\s*%?\d/.test(raw)) return;
    const decimals = m[0].includes(",") ? m[0].split(",")[1].length : 0;
    const target = parseFloat(m[0].replace(/\./g, "").replace(",", "."));
    const t0 = performance.now(), dur = 1200;
    const tick = (t) => {
      const p = Math.min(1, (t - t0) / dur), v = target * (1 - Math.pow(1 - p, 3));
      const s = decimals ? v.toFixed(decimals).replace(".", ",") : Math.round(v).toLocaleString("tr-TR");
      el.textContent = raw.replace(m[0], s);
      if (p < 1) requestAnimationFrame(tick);
      else el.textContent = raw;
    };
    requestAnimationFrame(tick);
  };

  const aiAnswer = (el) => {
    const box = el.querySelector("[data-ht-answer]");
    if (!box) return;
    const text = box.textContent.trim();
    box.textContent = "";
    let i = 0;
    setTimeout(function step() {
      i = Math.min(text.length, i + 3);
      box.textContent = text.slice(0, i);
      if (i < text.length) setTimeout(step, 22);
    }, 2400);
  };

  const phoneTaps = (el) => {
    const btns = [...el.querySelectorAll(".ht-ps-actions span")];
    btns.forEach((b, i) => {
      setTimeout(() => b.classList.add("is-tap"), 700 + i * 650);
      setTimeout(() => b.classList.remove("is-tap"), 1200 + i * 650);
    });
  };

  /* ---------- Vizör zaman kodu ---------- */
  let tc;
  const timecode = () => {
    clearInterval(tc);
    const els = document.querySelectorAll(".ht [data-ht-timecode]");
    if (!els.length || reduce) return;
    const t0 = Date.now(), pad = (n) => String(n).padStart(2, "0");
    tc = setInterval(() => {
      const s = Math.floor((Date.now() - t0) / 1000);
      const v = `${pad(Math.floor(s / 3600))}:${pad(Math.floor(s / 60) % 60)}:${pad(s % 60)}`;
      els.forEach((e) => (e.textContent = v));
    }, 1000);
  };

  /* ---------- Tahmini teslim tarihi (hafta sonları atlanır) ---------- */
  const eta = () => {
    document.querySelectorAll(".ht [data-ht-eta]").forEach((el) => {
      const min = +el.dataset.min || 0, max = +el.dataset.max || 0;
      const [ch, cm] = (el.dataset.cutoff || "15:00").split(":").map(Number);
      if (!max) return;
      const now = new Date();
      const start = new Date(now);
      if (now.getHours() * 60 + now.getMinutes() >= ch * 60 + (cm || 0)) start.setDate(start.getDate() + 1);
      const addBiz = (d, n) => {
        const r = new Date(d);
        while (r.getDay() === 0 || r.getDay() === 6) r.setDate(r.getDate() + 1);
        for (let i = 0; i < n; ) { r.setDate(r.getDate() + 1); if (r.getDay() !== 0 && r.getDay() !== 6) i++; }
        return r;
      };
      const f = (d) => d.toLocaleDateString("tr-TR", { day: "numeric", month: "long", weekday: "short" });
      const a = addBiz(start, min), b = addBiz(start, max);
      el.querySelector("[data-ht-eta-text]").innerHTML = `Tahmini teslim: <b>${f(a)} – ${f(b)}</b>`;
    });
  };

  /* ---------- Alt menü: aktif bölüm + yapışkan konum ---------- */
  const subnav = () => {
    const nav = document.querySelector(".ht-subnav");
    if (!nav) return;
    // Temanın yapışkan/sabit header'ının alt kenarını bul (gizlenip açılan header'lar dahil)
    const headerBottom = () => {
      let bottom = 0;
      document.elementsFromPoint(innerWidth / 2, 2).forEach((el) => {
        if (nav.contains(el)) return;
        for (let n = el; n && n !== document.body; n = n.parentElement) {
          const pos = getComputedStyle(n).position;
          if (pos === "sticky" || pos === "fixed") { bottom = Math.max(bottom, n.getBoundingClientRect().bottom); break; }
        }
      });
      return Math.max(0, Math.round(bottom));
    };
    let raf = 0;
    const setTop = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => nav.style.setProperty("--ht-subnav-top", headerBottom() + "px")); };
    setTop();
    addEventListener("resize", setTop, { passive: true });
    addEventListener("scroll", setTop, { passive: true });
    const links = [...nav.querySelectorAll("a[href^='#']")];
    const map = new Map(links.map((a) => [document.getElementById(a.hash.slice(1)), a]).filter(([t]) => t));
    const o = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        links.forEach((a) => a.setAttribute("aria-current", a === map.get(en.target)));
        const a = map.get(en.target), row = a?.parentElement;
        if (row) row.scrollTo({ left: a.offsetLeft - row.clientWidth / 2 + a.offsetWidth / 2, behavior: reduce ? "auto" : "smooth" });
      });
    }, { rootMargin: "-45% 0px -50% 0px" });
    map.forEach((_, t) => o.observe(t));
  };

  /* ---------- Mobil yapışkan sepet: temanın ürün formu görünmezken ---------- */
  const sticky = () => {
    const bar = document.querySelector("[data-ht-sticky]");
    if (!bar) return;
    const mainForm = [...document.querySelectorAll('form[action*="/cart/add"]')].find((f) => !bar.contains(f));
    const btn = bar.querySelector("button");
    if (mainForm) {
      // Temada seçilen varyantı sepete eklerken kullan
      bar.querySelector("form").addEventListener("submit", () => {
        const id = mainForm.querySelector('[name="id"]')?.value;
        if (id) bar.querySelector('[name="id"]').value = id;
      });
      new IntersectionObserver(([e]) => {
        const on = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle("is-on", on);
        bar.inert = !on;
      }).observe(mainForm.querySelector('[type="submit"]') || mainForm);
    } else {
      bar.classList.add("is-on");
    }
    btn.inert = false;
  };

  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", init) : init();
  // Tema düzenleyicide bölüm eklenince/değişince yeniden başlat
  ["shopify:section:load", "shopify:block:select"].forEach((ev) => document.addEventListener(ev, init));
})();
